(function () {
  'use strict';

  var occasionMap = {
    'thank-you': '/collections/thank-you',
    welcome: '/collections/employee-client-gifts',
    birthday: '/collections/gift-boxes',
    sympathy: '/collections/sympathy-gifts',
    'get-well': '/collections/get-well-gifts',
    holiday: '/collections/holiday',
    'just-because': '/collections/gift-boxes'
  };

  var budgetRange = {
    'under-100': { gte: null, lte: 99 },
    '100-150': { gte: 100, lte: 150 },
    'over-150': { gte: 150, lte: null }
  };

  document.querySelectorAll('[data-gift-finder]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var data = new FormData(form);
      var occasion = data.get('occasion');
      var recipient = data.get('recipient');
      var budget = data.get('budget');
      var base = occasion && occasionMap[occasion] ? occasionMap[occasion] : '/collections/gift-boxes';
      var params = [];

      if (recipient) {
        params.push('recipient=' + encodeURIComponent(recipient));
      }

      if (budget && budgetRange[budget]) {
        var range = budgetRange[budget];
        if (range.gte !== null) {
          params.push('filter.v.price.gte=' + range.gte);
        }
        if (range.lte !== null) {
          params.push('filter.v.price.lte=' + range.lte);
        }
      }

      window.location.href = base + (params.length ? '?' + params.join('&') : '');
    });
  });
})();
